import { c as _c } from "react/compiler-runtime";
// «Пункт выдачи {перевозчик}»: карточка выбранного пункта (адрес, режим
// работы) + «Изменить пункт выдачи», и список ранее выбранных пунктов с
// удалением и пометкой «Недоступен для этого товара» — кадры 6–7 макета
// «5.1 Оформление заказа-2».
import { ClockIcon, MarkerPinIcon, TrashIcon } from "@/components/icons";
import { toast } from "sonner";
import { api, type SavedPickupPoint } from "@/api";
import { CheckoutModal, IconAction, ListRow, ModalButton } from "./ui";
export const carrierTitle = (carrier: string): string => carrier === "sdek" ? "СДЭК" : carrier === "5post" ? "5Post" : carrier === "flat" ? "OSMIX" : carrier;
export function PickupInfoModal(t0) {
  const $ = _c(16);
  const {
    open,
    onOpenChange,
    point,
    onChange
  } = t0;
  const t1 = `Пункт выдачи ${carrierTitle(point.carrier)}`;
  let t2;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <MarkerPinIcon size={24} className="shrink-0 text-ds-primary" />;
    $[0] = t2;
  } else {
    t2 = $[0];
  }
  let t3;
  if ($[1] !== point.address) {
    t3 = <p className="flex items-center gap-2 text-[14px] leading-[18px] text-black">{t2}{point.address}</p>;
    $[1] = point.address;
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  let t4;
  if ($[3] !== point.workTime) {
    t4 = point.workTime && <p className="flex items-center gap-2 text-[14px] leading-[18px] text-black"><ClockIcon size={24} className="shrink-0 text-ds-primary" />{point.workTime}</p>;
    $[3] = point.workTime;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  let t5;
  if ($[5] !== t3 || $[6] !== t4) {
    t5 = <div className="mb-5 flex flex-col gap-2.5 rounded-[12px] bg-[#F8F8F8] p-2.5">{t3}{t4}</div>;
    $[5] = t3;
    $[6] = t4;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  let t6;
  if ($[8] !== onChange) {
    t6 = <ModalButton onClick={onChange} data-testid="pickup-change">Изменить пункт выдачи</ModalButton>;
    $[8] = onChange;
    $[9] = t6;
  } else {
    t6 = $[9];
  }
  let t7;
  if ($[10] !== onOpenChange || $[11] !== open || $[12] !== t1 || $[13] !== t5 || $[14] !== t6) {
    t7 = <CheckoutModal open={open} onOpenChange={onOpenChange} title={t1} testId="pickup-info-modal">{t5}{t6}</CheckoutModal>;
    $[10] = onOpenChange;
    $[11] = open;
    $[12] = t1;
    $[13] = t5;
    $[14] = t6;
    $[15] = t7;
  } else {
    t7 = $[15];
  }
  return t7;
}
export function PickupListModal(t0) {
  const $ = _c(16);
  const {
    open,
    onOpenChange,
    carrier,
    points,
    selectedCode,
    isAvailable,
    onSelect,
    onAdd,
    onChanged
  } = t0;
  let t1;
  if ($[0] !== onChanged) {
    t1 = async p => {
      ;
      try {
        await api.buyer.deletePickupPoint(p.carrier, p.code);
        onChanged();
      } catch (t2) {
        const e = t2;
        toast.error(e instanceof Error ? e.message : "\u041D\u0435 \u0443\u0434\u0430\u043B\u043E\u0441\u044C \u0443\u0434\u0430\u043B\u0438\u0442\u044C \u043F\u0443\u043D\u043A\u0442 \u0432\u044B\u0434\u0430\u0447\u0438");
      }
    };
    $[0] = onChanged;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const remove = t1;
  const t2 = `Пункт выдачи ${carrierTitle(carrier)}`;
  let t3;
  if ($[2] !== isAvailable || $[3] !== onSelect || $[4] !== points || $[5] !== remove || $[6] !== selectedCode) {
    t3 = points.length > 0 && <div className="mb-5 flex flex-col rounded-[12px] bg-[#F8F8F8]">{[...points].sort((x, y) => Number(isAvailable(y)) - Number(isAvailable(x))).map(p_0 => {
        const available = isAvailable(p_0);
        return <ListRow key={`${p_0.carrier}:${p_0.code}`} selected={available && p_0.code === selectedCode} disabled={!available} note={available ? undefined : "\u041D\u0435\u0434\u043E\u0441\u0442\u0443\u043F\u0435\u043D \u0434\u043B\u044F \u044D\u0442\u043E\u0433\u043E \u0442\u043E\u0432\u0430\u0440\u0430"} onSelect={() => onSelect(p_0)} actions={<IconAction label={"\u0423\u0434\u0430\u043B\u0438\u0442\u044C \u043F\u0443\u043D\u043A\u0442 \u0432\u044B\u0434\u0430\u0447\u0438"} onClick={() => void remove(p_0)}><TrashIcon size={20} /></IconAction>}>{[carrierTitle(p_0.carrier), p_0.address].join(", ")}</ListRow>;
      })}</div>;
    $[2] = isAvailable;
    $[3] = onSelect;
    $[4] = points;
    $[5] = remove;
    $[6] = selectedCode;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  let t4;
  if ($[8] !== onAdd) {
    t4 = <ModalButton onClick={onAdd} data-testid="pickup-add">Добавить пункт выдачи</ModalButton>;
    $[8] = onAdd;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  let t5;
  if ($[10] !== onOpenChange || $[11] !== open || $[12] !== t2 || $[13] !== t3 || $[14] !== t4) {
    t5 = <CheckoutModal open={open} onOpenChange={onOpenChange} title={t2} testId="pickup-list-modal">{t3}{t4}</CheckoutModal>;
    $[10] = onOpenChange;
    $[11] = open;
    $[12] = t2;
    $[13] = t3;
    $[14] = t4;
    $[15] = t5;
  } else {
    t5 = $[15];
  }
  return t5;
}